export enum LocalStorageKeys {
    TasksFilter = 'tasks-filter',
}
